import { CoObjectItem } from "../components/interfaces/CoObject";
import { createContentControlForCoObject } from "./ContentControl";
import { getContentControlById } from "./WordDocumentPart";

/* global Word */
export function insertFreeText(coObject: CoObjectItem): Promise<any> {
  return Word.run(async (context) => {
    const ccId = await createContentControlForCoObject(coObject);
    const wordContentControl = await getContentControlById(context, ccId);

    wordContentControl.insertText("", "Start");
    await context.sync();
    return wordContentControl.id;
  }).catch((error) => {
    // eslint-disable-next-line no-undef
    console.log(error);
    return null;
  });
}
